import { render } from "./Colors.vue?vue&type=template&id=e86be776&scoped=true"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"

import "./Colors.vue?vue&type=style&index=0&id=e86be776&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86be776"]])

export default __exports__